module.exports = __webpack_public_path__ + "img/JustNamed.9595756e.svg";